import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import ChargePointPartnerListScreen from './screens/ChargePointPartnerListScreen';
import ChargePointPartnerDetailScreen from './screens/ChargePointPartnerDetailScreen';
import AgencySaleAddOrderScreen from 'features/Agency/screens/AgencySaleAddOrderScreen';
import EditAgencyScreen from 'features/ManageDealer/screens/EditAgencyScreen';

ManageChargePointPartner.propTypes = {};

function ManageChargePointPartner(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0 pb-4">
                <Routes>
                    <Route path="" element={<ChargePointPartnerListScreen />} />
                    <Route
                        path={"/add"}
                        element={<EditAgencyScreen agencyRole="CHARGEPOINT" />}
                    />
                    <Route path="/:agencyId" element={<ChargePointPartnerDetailScreen />} />
                    {/* <Route path="/:agencyId/sale/:saleId" element={<AgencySaleDetailScreen />} /> */}
                    <Route
                        path={"/:agencyId/edit"}
                        element={<EditAgencyScreen agencyRole="CHARGEPOINT" />}
                    />
                    <Route path="/add-order" element={<AgencySaleAddOrderScreen removeBaseLayout={true} />} />
                    <Route path="/:agencyId/add-order" element={<AgencySaleAddOrderScreen removeBaseLayout={true} />} />
                    <Route path="*" element={<>Not found</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default ManageChargePointPartner;
